import { createSlice } from "@reduxjs/toolkit";

const webStoreUserSlice = createSlice({
  name: "webStoreUser",
  initialState: {
    user: {},
  },

  reducers: {
    setUser: (state, action) => {
      state.user = action.payload
    },

    dropUser: (state, action) => {
      state.user = null
    },
  },
});

export default webStoreUserSlice.reducer;
export const { setUser,dropUser } = webStoreUserSlice.actions;
